import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";

import "../../style/Reusable.css";
import "../../style/components/IngredientList.css";
import "../../style/components/HistorySlide.css";

import { useScroll } from "framer-motion";
import LazyImage from "../generics/LazyImage";

import CloseButton from "../generics/CloseButton";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";

const getScrollRange = (image, index, imageNo) => {
  const minScroll = (1 / imageNo) * index;
  const maxScroll = (1 / imageNo) * (index + 1);

  return { image, index, minScroll, maxScroll };
};

function IngredientBlog({ ingredient, handleBack, ingredientText }) {
  const [activeElement, setActiveElement] = useState(0);
  const { images, content, title } = ingredient;

  const imageScrollRange = images.map((image, index) =>
    getScrollRange(image, index, images.length)
  );

  const handleScrollTop = () => {
    imageScrollRange.forEach((image) => {
      const { index, minScroll, maxScroll } = image;
      const { current } = scrollYProgress;
      //0-1
      if (minScroll < current && maxScroll > current) setActiveElement(index);
    });
  };

  const ref = useRef(null);
  const container = useRef(null);
  const { scrollYProgress } = useScroll({ container, target: ref });

  useEffect(() => {
    setActiveElement(0);
  }, [ingredient]);

  return (
    <div>
      <div className="ingredient">
        <CloseButton onClick={() => handleBack(true)} />
        <div className="ingredient-image-container">
          {images.map((image, index) => (
            <Grid key={index} container spacing={0} className="ingredient-list">
              <Grid size={{ xs: 6 }}>
                <div
                  className={`ingredient-image ${
                    index === activeElement ? "display-block" : "display-none"
                  }`}
                >
                  <LazyImage
                    className="ingredient-lazy-image zoom"
                    alt=""
                    imageSrc={image}
                  />
                </div>
              </Grid>
            </Grid>
          ))}
        </div>
        <div
          className="ingredient-text-container"
          ref={container}
          onScroll={handleScrollTop}
        >
          {content.map((paragraph, index) => (
            <Grid
              key={index}
              container
              spacing={0}
              className="ingredient-text-list"
            >
              <Grid size={{ xs: 6 }}></Grid>
              <Grid size={{ xs: 6 }}>
                <div className="ingredient-details-card">
                  <div className="ingredient-card-text">
                    {index === 0 && (
                      <h1 style={{ textAlign: "left" }}>{title}</h1>
                    )}
                    <div className="body-b2 ingredient-text-body">
                      {paragraph}
                    </div>
                    <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          ))}
        </div>
        <div className="custom-button-link ingredient-button ingredient-controller-label other-ingredient-controller">
          <KeyboardArrowLeftRoundedIcon style={{ marginBottom: 2 }} />
          <button
            className="custom-button-link ingredient-button-underline"
            onClick={() => handleBack()}
          >
            {ingredientText.buttonText.listing}
          </button>
        </div>
      </div>
    </div>
  );
}

export default IngredientBlog;
